(function ($, Drupal) {
  Drupal.behaviors.viewsExposedFilters = {
    attach: function (context, settings) {
      $(document).ready(function() {
        if ($('.views-exposed-form').length) {
          $('.view-filters .views-exposed-form .views-exposed-form__item.views-exposed-form__item input[type=\'text\']').each(function() {
            if ($(this).val()) {
              $(this).addClass('changed');
            } else {
              $(this).removeClass('changed')
            }
          });

          $('.view-filters .views-exposed-form .views-exposed-form__item.views-exposed-form__item input[type=\'text\']').on('keyup', function() {
            if ($(this).val()) {
              $(this).addClass('changed');
            } else {
              $(this).removeClass('changed')
            }
          });

          $('.view-filters .views-exposed-form .views-exposed-form__item select').each(function() {
            $(this).addClass('changed');

            if ($(this).val() === 'All') {
              $(this).removeClass('changed')
            }
          });

          $('.view-filters .views-exposed-form .views-exposed-form__item select').on('change', function(e) {
            $(this).addClass('changed');

            if ($(this).val() === 'All') {
              $(this).removeClass('changed')
            }
          })
        }
      });
    }
  };
})(jQuery, Drupal);
